import { v4 as uuidv4 } from "uuid";
import { AddressModel } from "./data.address.model";

export class EmploymentModel {
	employerName?: string;
	employerNameError?: string;
	dateStarted?: string;
	dateStartedError?: string;
	dateEnded?: string;
	jobTitle?: string;
	reasonForLeaving?: string;
	duties?: string;
	salary?: string;
	referenceAddress?: AddressModel;
	employmentId?: string;
	orderIndex: number;

	constructor(data: any = {}) {
		this.employerName = data.employerName || "";
		this.dateStarted = data.dateStarted || "";
		this.dateEnded = data.dateEnded || "";
		this.jobTitle = data.jobTitle || "";
		this.reasonForLeaving = data.reasonForLeaving || "";
		this.duties = data.duties || "";
		this.salary = data.salary || "";
		this.referenceAddress = data.referenceAddress || new AddressModel();
		this.employmentId = data.employmentId || uuidv4();
		this.orderIndex = data.orderIndex || 0;
	}
}
